// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603261130/js/" + chunkId + "." + {"44":"ad1f94cd","225":"00e9bc5b","481":"c5778d22","486":"eb4ba3fe","770":"a377a6ae"}[chunkId] + ".0.7462565319677354.chunk.js";
};